import getHeaderFooterClickEventName from '../helpers/getHeaderFooterClickEventName';

import {
  transformNodeText,
  getCompanyFromNode,
  getHref,
  getCurrentPage,
  getRegionalHeaderLinkName,
  getVideoPayload,
  getDownloadPayload,
  downloadEventName,
  featureExploreEventName,
} from '../helpers/analytics';

module.exports = {
  "header-logo-click": (currentPage) => ({
    eventType: 'click',
    eventName: `splash.header.plangrid.click`,
    payload: {
      'current_page': getCurrentPage(currentPage),
    },
  }),
  "header-link-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: getHeaderFooterClickEventName(node, 'header'),
    payload: {
      'current_page': getCurrentPage(currentPage),
    },
  }),
  "header-globe-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.regional.header.click',
    payload: {
      'locale': getRegionalHeaderLinkName(node),
    },
  }),
  "regional-header-link-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.regional.header.click',
    payload: {
      'link': getRegionalHeaderLinkName(node),
      'locale': getCurrentPage(currentPage),
    },
  }),
  "regional-cta-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.regional.signup.submit',
    payload: {
      'locale': getCurrentPage(currentPage),
    },
  }),
  "header-phone-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.header.phone.click',
    payload: {
      'current_page': currentPage,
    },
  }),
  "header-login-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.header.login.click',
    payload: {
      'current_page': getCurrentPage(currentPage),
    },
  }),
  "header-signup-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.header.signup.click',
    payload: {
      'current_page': getCurrentPage(currentPage),
    },
  }),
  "header-mobile-expand-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.header.expand.click',
    payload: {
      'current_page': currentPage,
    },
  }),
  "footer-link-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: getHeaderFooterClickEventName(node, 'footer'),
    payload: {
      'current_page': currentPage,
    },
  }),
  "footer-ios-download-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.download.click',
    payload: {
      'current_page': currentPage,
      'button_place': 'footer',
      platform: 'ios',
    },
  }),
  "footer-android-download-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.download.click',
    payload: {
      'current_page': currentPage,
      'button_place': 'footer',
      platform: 'android',
    },
  }),
  "footer-windows-download-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.download.click',
    payload: {
      'current_page': currentPage,
      'button_place': 'footer',
      platform: 'windows',
    },
  }),
  "home-product-explore-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.product_explore.click',
  }),
  "home-video-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.video.click',
  }),
  "home-video-hover-no-click": (currentPage) => ({
    eventType: 'hover-no-click',
    eventName: 'splash.home.video.hover',
  }),
  "home-testimonials-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.testimonials.click',
  }),
  "home-mainCTA-ios-download-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.download.click',
    payload: {
      'button_place': 'main_CTA',
      'platform': 'ios',
    },
  }),
  "home-mainCTA-windows-download-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.download.click',
    payload: {
      'button_place': 'main_CTA',
      'platform': 'windows',
    },
  }),
  "home-mainCTA-android-download-click": (currentPage) => ({
    eventType: 'click',
    eventName: 'splash.home.download.click',
    payload: {
      'button_place': 'main_CTA',
      'platform': 'android',
    },
  }),
  "home-secondaryCTA-signup-click": () => ({
    eventType: 'click',
    eventName: 'splash.signup.submit',
    payload: {
      'button_place': 'secondary_CTA',
    },
  }),
  "home-mainCTA-signup-click": () => ({
    eventType: 'click',
    eventName: 'splash.signup.submit',
    payload: {
      'button_place': 'main_CTA',
    },
  }),
  "home-projects-category-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.home.projects_category.click',
    payload: {
      'context': transformNodeText(node.text),
    },
  }),
  "home-projects-category-hover": (currentPage, node) => ({
    eventType: 'hover',
    eventName: 'splash.home.projects_category.hover',
    payload: {
      'context': transformNodeText(node.text),
    },
  }),
  "home-projects-explore-click": () => ({
    eventType: 'click',
    eventName: 'splash.home.projects_explore.click',
  }),
  "product-mainCTA-signup-click": () => ({
    eventType: 'click',
    eventName: 'splash.product.signup.click',
    payload: {
      'button_place': 'main_cta',
    },
  }),
  "product-secondaryCTA-signup-click": () => ({
    eventType: 'click',
    eventName: 'splash.product.signup.click',
    payload: {
      'button_place': 'secondary_cta',
    },
  }),
  "product-bottomCTA-signup-click": () => ({
    eventType: 'click',
    eventName: 'splash.product.signup.click',
    payload: {
      'button_place': 'bottom_cta',
    },
  }),
  "product-ipad-arrow-click": () => ({
    eventType: 'click',
    eventName: 'splash.product.ipad_features.click',
  }),
  "product-feature-text-click": () => ({
    eventType: 'click',
    eventName: 'splash.product.text_features.click',
  }),
  "product-download-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: downloadEventName(currentPage),
    payload: getDownloadPayload(node, currentPage),
  }),
  "feature-page-demo-click": (currentPage) => ({
    eventType: 'click',
    eventName: `splash.${currentPage}.demo.click`,
  }),
  "feature-page-video-click": (currentPage) => ({
    eventType: 'click',
    eventName: `splash.${currentPage}.video.click`,
  }),
  "feature-link-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: `splash.${currentPage}.feature.click`,
    payload: {
      'page-click': transformNodeText(node.text),
    },
  }),
  "header-contact-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: `splash.${currentPage}.contact_sales.click`,
  }),
  "sidenav-filter-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: `splash.${currentPage}.filter.click`,
    payload: {
      type: transformNodeText(node.getAttribute('data-link-category')),
    },
  }),
  "sidenav-mobile-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: `splash.${currentPage}.dropdown.click`,
  }),
  "partner-sidenav-become-a-partner-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.resources.partners.contact.click',
    payload: {
      context: 'sidenav',
    },
  }),
  "partner-sidenav-explore-our-api-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.resources.partners.doc.click',
    payload: {
      context: 'sidenav',
    },
  }),
  "projects-project-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.projects.project.click',
    payload: {
      company_name: getCompanyFromNode(node),
      project_name: getHref(node),
    },
  }),
  "case-study-quote-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.projects.quote.click',
    payload: {
      project_name: currentPage,
    },
  }),
  "case-study-download-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.projects.download.click',
    payload: {
      project_name: currentPage,
    },
  }),
  "case-study-signup-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.projects.signup.click',
    payload: {
      project_name: currentPage,
    },
  }),
  "video-feature-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: featureExploreEventName(currentPage),
    payload: getVideoPayload(node, currentPage),
  }),
  "events-filter-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.events.filter.click',
    payload: {
      'filter': transformNodeText(node.getAttribute('value')),
    },
  }),
  "userGroups-lead-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.user_groups.lead.click',
  }),
  "userGroups-join-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.user_groups.join.click',
  }),
  "userGroups-faq-click": (currentPage, node) => ({
    eventType: 'click',
    eventName: 'splash.user_groups.faq.click',
  }),
};



// WEBPACK FOOTER //
// ./src/pages/helpers/analyticsHandlers.js